import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

// routing
import Routes from 'routes';
import { QueryClientProvider } from '@tanstack/react-query';

// project imports
import Locales from 'shared/components/ui-component/Locales';
import NavigationScroll from 'shared/components/layout/NavigationScroll';
import RTLLayout from 'shared/components/ui-component/RTLLayout';
import Snackbar from 'shared/components/ui-component/extended/Snackbar';

import ThemeCustomization from 'shared/themes';
import { queryClient } from 'api';
import { AuthProvider } from 'modules/auth/contexts/authContext';
import { LocationsProvider } from 'modules/locations/contexts/locationsContext';

// ==============================|| APP ||============================== //

/**
 * Represents the main application component.
 * Manages loading state and renders the application UI.
 */
const App = () => {
    return (
        <ThemeCustomization>
            {/* RTLLayout: Provider for RTL support */}
            <RTLLayout>
                {/* Locales: Provider for localization support */}
                <Locales>
                    {/* NavigationScroll: Provider for consistent navigation scroll behavior */}
                    <NavigationScroll>
                        {/* QueryClientProvider: Provider for handling API calls, state and cache data */}
                        <QueryClientProvider client={queryClient}>
                            {/* LocalizationProvider: Provider for handling date/time localization */}
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                {/* LocationsProvider: Provider for handling app locations context */}
                                <LocationsProvider>
                                    {/* AuthProvider: Provider for handling authentication context */}
                                    <AuthProvider>
                                        <>
                                            <Routes />
                                            <Snackbar />
                                        </>
                                    </AuthProvider>
                                </LocationsProvider>
                            </LocalizationProvider>
                        </QueryClientProvider>
                    </NavigationScroll>
                </Locales>
            </RTLLayout>
        </ThemeCustomization>
    );
};

export default App;
